var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 pt-0 pb-0"},[_vm._v("Deseja realmente excluir?")])}
var staticRenderFns = []

export { render, staticRenderFns }